import React from "react";
import styled from "styled-components";
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";
import { ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import Modal from "common-components/Modal/Modal";
import Button from "common-components/Buttons";
import StyledLink from "common-components/StyledLink";

const ActiveAndInactiveAccounts = ({ modalContent, continueCloseModal, closeModal, guestFlowUrl, ...props }) => (
  <Modal id="modalStyle" contentLabel="active and inactive accounts modal" visibleModal closeModal={closeModal} {...props}>
    
    <ModalTitle> <H2>{modalContent.section_title}</H2></ModalTitle>
    <ModalBody>
        {convertStringToElements(modalContent.section_description)}
        </ModalBody>
        <ModalFooter
        buttonData={{
          primary: {
            width: '100%',
            children: modalContent.buttons[0].text,
            onClick: () => continueCloseModal()
          },
          close: {
            width: '100%',
            children: modalContent.buttons[1].text,
            onClick: () => closeModal()
          },
        }}
      />
 </Modal >         
     
    );

 

export default ActiveAndInactiveAccounts;

const Container = styled.div`
  max-width: 420px;

  ${media.mobile`
    padding-right: 0;
  `}
`;

const Div = styled.div`
  margin-top: 32px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;

  p {
    padding: 10px 0;
  }

  ${media.mobile`
  @media only screen and (max-width: 480px) {
    .buttonContainer {
      position:absolute;
      bottom:10px;
      right:0px;
      left:0px;
      margin:20px
    }
  }
 
`}
`;

const H2 = styled.h2`
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 32px;
  ${media.mobile`
  margin-right: 23px;
  font-weight: 400;
  font-size: 24px;
`}
`;
